import React from 'react';
import { LandmarkIcon, BanknoteIcon, HeartPulseIcon, ScaleIcon, GraduationCapIcon, TruckIcon, ArrowRightIcon } from 'lucide-react';
const industries = [{
  icon: LandmarkIcon,
  title: 'Государственные услуги',
  description: 'Автоматизация обработки заявлений граждан, оцифровка архивов и ускорение выдачи разрешений и справок.',
  useCases: ['Электронный документооборот', 'Оцифровка архивов', 'Обработка заявлений']
}, {
  icon: BanknoteIcon,
  title: 'Финансовый сектор',
  description: 'Извлечение данных из счетов-фактур, договоров и отчётности для автоматизации комплаенса и аудита.',
  useCases: ['Обработка счетов', 'KYC-верификация', 'Анализ договоров']
}, {
  icon: HeartPulseIcon,
  title: 'Здравоохранение',
  description: 'Распознавание медицинских карт, рецептов и страховых документов с высокой точностью и защитой данных.',
  useCases: ['Медицинские карты', 'Рецепты и направления', 'Страховые формы']
}, {
  icon: ScaleIcon,
  title: 'Юриспруденция',
  description: 'Интеллектуальный поиск по судебным решениям, контрактам и нормативным актам для ускорения правовой работы.',
  useCases: ['Анализ контрактов', 'Судебные документы', 'Нормативные акты']
}, {
  icon: GraduationCapIcon,
  title: 'Образование',
  description: 'Оцифровка учебных материалов, дипломов и научных публикаций для создания цифровых библиотек знаний.',
  useCases: ['Научные статьи', 'Дипломы и аттестаты', 'Учебные архивы']
}, {
  icon: TruckIcon,
  title: 'Логистика',
  description: 'Обработка транспортных накладных, таможенных деклараций и товаросопроводительных документов в потоковом режиме.',
  useCases: ['Накладные и CMR', 'Таможенные декларации', 'Инвентаризация']
}];
export function Industries() {
  return <section className="py-24 bg-gray-50 border-t border-gray-200" data-id="element-167">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-169">
          <p className="text-sm font-semibold text-blue-900 uppercase tracking-wider mb-3" data-id="element-170">
            Отрасли
          </p>
          <h2 className="text-3xl md:text-4xl font-sans font-bold text-gray-900 mb-6" data-id="element-171">
            Технологии для ключевых индустрий
          </h2>
          <p className="text-lg text-gray-500" data-id="element-172">
            ScanMind адаптируется под специфику каждой отрасли, обеспечивая
            точное распознавание и поиск по документам любой сложности.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-173">
          {industries.map((industry, index) => <div key={index} className="group bg-white rounded-xl border border-gray-200 p-8 hover:shadow-lg hover:border-gray-300 transition-all duration-200" data-id="element-174">
              <div className="flex items-start gap-4 mb-5" data-id="element-175">
                <div className="w-11 h-11 bg-blue-950/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-176">
                  <industry.icon className="w-5 h-5 text-blue-900" data-id="element-177" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 pt-2" data-id="element-178">
                  {industry.title}
                </h3>
              </div>

              <p className="text-gray-500 leading-relaxed mb-6 text-sm" data-id="element-179">
                {industry.description}
              </p>

              <div className="flex flex-wrap gap-2" data-id="element-180">
                {industry.useCases.map((useCase, i) => <span key={i} className="inline-flex items-center px-3 py-1 rounded-md bg-gray-100 text-xs font-medium text-gray-600" data-id="element-181">
                    {useCase}
                  </span>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}